export enum MixpanelEvent {
  QUERY_WEBSITE_GET_STARTED = 'signup.account-selection.view.arrived-from.home-page-get-started',
  QUERY_WEBSITE_LOGIN = 'signup.account-selection-page.view.arrived-from.home-page-login',
  QUERY_WEBSITE_PRICING_PAGE_GET_STARTED = 'signup.account-selection-page.view.arrived-from.home-page-login',
  QUERY_MAIL_USER_INVITE = 'signup.account-selection-page.view.arrived-from.user-invite',
  QUERY_MAIL_OWNER_INVITE = 'signup.account-selection-page.view.arrived-from.owner-invite',

  ARRIVED_TO_SIGNUP_PAGE = 'signup.account-selection-page.view.arrived-from.no-origin',
  CONTINUE_WITH_GOOGLE_CLICK = 'signup.account-selection-page.click.continue-with-google',
  CONTINUE_WITH_MICROSOFT_CLICK = 'signup.account-selection-page.click.continue-with-microsoft',
  SIGNUP_TALK_TO_SALES_CLICK = 'signup.account-selection-page.click.talk-to-sales',
  SIGNUP_CONTACT_US_CLICK = 'signup.account-selection-page.click.contact-us',
  SIGNUP_TERMS_OF_USE_CLICK = 'signup.account-selection-page.click.tos',
  SIGNUP_PRIVACY_POLICY_CLICK = 'signup.account-selection-page.click.privacy-policy',

  ARRIVED_TO_PRICING_PAGE = 'signup.pricing-page.view',
  PRICING_PAGE_CHOOSED_MONTHLY_PAY = 'signup.pricing-page.click.toggle-to-monthly',
  PRICING_PAGE_CHOOSED_YEARLY_PAY = 'signup.pricing-page.click.toggle-to-yearly',
  PRICING_PAGE_CHOOSED_PROFESSIONAL_PLAN = 'signup.pricing-page.click.professional',
  PRICING_PAGE_CHOOSED_TALK_TO_SALES = 'signup.pricing-page.click.enterprise.talk-to-sales',
  PRICING_PAGE_EXPAND_VIEW_ALL_FEATURES = 'signup.pricing-page.click.view-all-features',
  PRICING_PAGE_BACK_BUTTON_CLICK = 'signup.pricing-page.click.back',
  PRICING_PAGE_LOGOUT_BUTTON_CLICK = 'signup.pricing-page.click.logout',
  PRICING_PAGE_BOOK_A_DEMO_BUTTON_CLICK = 'signup.pricing-page.click.book-a-demo',

  ARRIVED_TO_PAYMENT_DETAILS_PAGE = 'signup.payment-page.view',
  PAYMENT_DETAILS_PAGE_USERS_QTY_UPDATED = 'signup.payment-page.change.number-of-users',
  PAYMENT_DETAILS_PAGE_CHOOSED_MONTHLY_PAY = 'signup.payment-page.click.toggle-to-monthly',
  PAYMENT_DETAILS_PAGE_CHOOSED_YEARLY_PAY = 'signup.payment-page.click.toggle-to-yearly',
  PAYMENT_DETAILS_PAGE_SUBMIT_PAYMENT_FORM_CLICK = 'signup.payment-page.click.continue',
  PAYMENT_DETAILS_PAGE_SUBMIT_PAYMENT_FORM_SUCCESS = 'signup.payment-page.payment-form-submitted',
  PAYMENT_DETAILS_PAGE_SUBMIT_PAYMENT_FORM_FAILED = 'signup.payment-page.payment-form-failed',
  PAYMENT_DETAILS_PAGE_BACK_BUTTON_CLICK = 'signup.payment-page.click.back',
  PAYMENT_DETAILS_PAGE_LOGOUT_BUTTON_CLICK = 'signup.payment-page.click.logout',
  PAYMENT_DETAILS_PAGE_TERMS_OF_USE_CLICK = 'signup.payment-page.click.terms-of-use',
  PAYMENT_DETAILS_PAGE_PRIVACY_POLICY_CLICK = 'signup.payment-page.click.privacy-policy',
  PAYMENT_DETAILS_PAGE_BOOK_A_DEMO_BUTTON_CLICK = 'signup.payment-page.click.book-a-demo',

  ARRIVED_TO_PROCESSING_PAGE = 'signup.processing-page.view',
  PROCESSING_PAGE_PAYMENT_SUBMITTED = 'signup.processing-page.payment-success',
  PROCESSING_PAGE_PAYMENT_SUBMIT_FAILED = 'signup.processing-page.payment-failed',
  PROCESSING_PAGE_RETRY_PAYMENT = 'signup.processing-page.click.retry-payment',
  PROCESSING_PAGE_BOOK_A_DEMO_BUTTON_CLICK = 'signup.processing-page.click.book-a-demo',
}
